import { useFormikContext } from 'formik';
import { NoteFileField } from './note-file-field';
import { FileCheck, LoaderCircle } from 'lucide-react';
import { Trash } from 'iconsax-react';
import type { TMedia } from '@shared/types/media';
import { useDeleteMedia } from '@features/placements/services/delete-media';

const CreateNoteForm = () => {
  const { values, setFieldValue } = useFormikContext<{
    note: string;
    attachments: TMedia[];
  }>();
  const { mutateAsync: deleteMedia, isPending } = useDeleteMedia();

  const handleDeleteMedia = async (id: number) => {
    await deleteMedia(id).then(() => {
      const updatedAttachments = values.attachments.filter(
        (file) => file.id !== id
      );
      setFieldValue('attachments', updatedAttachments);
    });
  };

  return (
    <div className='mt-5'>
      <NoteFileField />

      {values.attachments &&
        values.attachments.length > 0 &&
        values.attachments.map((file, index) => (
          <div
            className='border border-primary-200 rounded-lg p-4 bg-primary-50 py-3 flex justify-between items-center w-full mb-2'
            key={index}
          >
            <div className='flex items-center gap-2'>
              <FileCheck
                size={40}
                color='#fff'
                fill='#584777'
              />
              <div className='flex flex-col'>
                <span className='text-sm font-medium'>{file.name}</span>
                <span className='text-xs text-muted-foreground font-extralight'>
                  {file.size}
                </span>
              </div>
            </div>
            {isPending ? (
              <LoaderCircle
                className='animate-spin'
                size={25}
              />
            ) : (
              <Trash
                onClick={() => handleDeleteMedia(file.id)}
                size={20}
                color='#FF3B30'
                className='cursor-pointer'
              />
            )}
          </div>
        ))}
    </div>
  );
};

export default CreateNoteForm;
